export default function initTextAnimation() {
  textAnimation();
}

// ============================================
// テキストアニメーション
// ============================================

function textAnimation() {
  const animationTargetElements = document.querySelectorAll(".js-text-fade-up");

  animationTargetElements.forEach((targetElement) => {
    const baseDelay = parseFloat(targetElement.dataset.delayGroup || 0) * 0.3;
    const texts = targetElement.textContent.trim();
    const textsArray = [];

    targetElement.textContent = "";

    [...texts].forEach((char, j) => {
      const delay = baseDelay + j * 0.05;
      textsArray.push(`<span><span style="animation-delay: ${delay}s">${char}</span></span>`);
    });

    targetElement.innerHTML = textsArray.join("");
  });
}
